import { useState, useEffect, useRef } from "react";
import { Row, Col, Table, Input, Spin, Tabs, message } from "antd";
import { LoadingOutlined, RightOutlined, DownOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import Back from "../../../../assets/images/backIcon.svg";
import CustomerSearch from "../../../../assets/images/c-serach.svg";
import Retrieve from "../../../../assets/images/retrieve.png";
import Cancel from "../../../../assets/images/cancel-new.svg";
import { cartHistory as cartHistoryService, upsertCart } from "../../../../services";
import { stock } from "../../Core/stock";
import useCartStore from "../../../../stores/useCartStore";

const { TabPane } = Tabs;

const SMParkedBillsView = ({
  colorVariable,
  posConfig,
  themeJSON,
  isParkedBill,
  setIsparkedBill,
  setIsInputFocused,
  setParkedBillSearchInput,
  setLayoutName,
  parkedBillSearchInput,
  searchParkedBill,
  onChangeParkedBill,
  keyboard,
  setInputName,
  setOpen,
  filterdParkedList,
  setFilterdParkedList,
  parkedList,
  columns,
  selectedKeys,
  expandedRowKeys,
  handleExpandPerkedData,
  tillData,
  pricePrecision,
  setTableValue,
  retrieveParkedData,
  upsertPOSLog,
  cart,
  setCart,
  setParkedBill,
  discardMessage,
  parkedBillRef,
  setShowPaymentMethods,
  setOrderHistoryDetails,
  setSelectedProductInCart,
  setProductStock,
  setTempCart,
  setShowCompleteSaleStock,
  setCompleteSaleStockData,
}) => {
  const [activeTab, setActiveTab] = useState("pending");
  const [loadingCart, setLoadingCart] = useState(false);
  const [cartHistoryData, setCartHistoryData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [expandedRowKey, setExpandedRowKey] = useState(null);

  const getCurrentMonthRange = () => {
    const startOfMonth = dayjs().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = dayjs().endOf("month").format("YYYY-MM-DD");
    return [startOfMonth, endOfMonth];
  };

  const getStatusForTab = (tab) => {
    switch (tab) {
      case "pending":
        return "DR";
      case "processed":
        return "CO";
      case "cancelled":
        return "CL";
      default:
        return "DR";
    }
  };

  const fetchCartHistory = async (status) => {
    setLoadingCart(true);
    try {
      const dateRange = getCurrentMonthRange();
      const filterBy = JSON.stringify({
        status: [status],
        DateRange: dateRange,
      });
      const sortBy = JSON.stringify({
        created: "DESC",
      });

      const response = await cartHistoryService({
        q: searchInput,
        filter_by: filterBy,
        sort_by: sortBy,
      });
      if (response?.status === 200) {
        const data = JSON.parse(response?.data?.data?.cartHistory || "[]");
        const transformedData = data.map((item, index) => ({
          ...item,
          key: item.cwr_store_discount_id || `${index}`,
        }));
        setCartHistoryData(transformedData);
      } else {
        message.warning("Something is wrong in cartHistory service");
      }
    } catch (error) {
      console.error("Error fetching cart history:", error);
    } finally {
      setLoadingCart(false);
    }
  };

  useEffect(() => {
    if (isParkedBill) fetchCartHistory("DR");
  }, [isParkedBill]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    const status = getStatusForTab(key);
    fetchCartHistory(status);
    setExpandedRowKey(null);
  };

  const toggleExpand = (key) => {
    setExpandedRowKey(expandedRowKey === key ? null : key);
  };

  const handleRetrieve = async (record) => {
    const selectedParkedBill = { ...record.cart_items, isRetrived: "Y", cwr_pos_cart_id: record?.cwr_pos_cart_id };
    let stockCheckResult = true;
    let isFinalValidation = false;
    let isCompleteSale = false;
    if (navigator.onLine && tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y") {
      stockCheckResult = await stock({
        cart: selectedParkedBill,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation,
        setTempCart,
        isCompleteSale: true,
        setShowCompleteSaleStock,
        setCompleteSaleStockData,
      });
      if (!stockCheckResult) {
        setSelectedProductInCart({});
        return;
      } else {
        setShowPaymentMethods(true);
        setOrderHistoryDetails([]);
        setIsparkedBill(false);
      }
    } else {
      setShowPaymentMethods(true);
      setOrderHistoryDetails([]);
      setIsparkedBill(false);
    }
    setCart(selectedParkedBill);
    setCartHistoryData([]);
    setExpandedRowKey(null);
  };

  const handleCancelSale = async (record) => {
    try {
      const cartPayload = {
        cwr_pos_cart_id: record.cwr_pos_cart_id,
        status: "CL",
        cart_json: JSON.stringify(record.cart_items || {}),
      };
      const response = await upsertCart({ cartJson: JSON.stringify(cartPayload) });
      if (response?.data?.data?.upsertCart?.status === "200") {
        message.success("Sale cancelled successfully");
        fetchCartHistory("DR");
      } else {
        message.warning("Cancel sale failed. Please try again.");
      }
    } catch (error) {
      console.error("Error cancelling sale:", error);
      message.warning("Cancel sale failed. Please try again.");
    }
  };

  if (posConfig?.saveParkedBills === "Y") {
    return (
      <div
        style={{
          background: colorVariable ? colorVariable : "#f3f4f9",
          height: "100vh",
        }}
      >
        <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
          <Col span={6}>
            <img
              src={Back}
              id="sm-parked-bill-back"
              onClick={() => {
                setIsparkedBill(false);
                setIsInputFocused(false);
                setParkedBillSearchInput("");
                setLayoutName("default");
                setCartHistoryData([]);
                setExpandedRowKey(null);
                setActiveTab("pending");
              }}
              style={{
                height: "3vw",
                paddingBottom: "0.7em",
                cursor: "pointer",
              }}
            />
            <span
              style={{
                paddingRight: "1vw",
                fontSize: "1.8em",
                fontWeight: 500,
                margin: "0.5em",
                paddingTop: "0.5em",
                color: "#0F0718",
              }}
            >
              Cart History
            </span>
          </Col>
          <Col
            span={18}
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Input
              placeholder="Search for customers"
              allowClear={false}
              style={{ width: "70%", borderRadius: "5px", border: "none" }}
              onPressEnter={() => {
                const status = getStatusForTab(activeTab);
                fetchCartHistory(status);
              }}
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
              value={searchInput}
            />
          </Col>
        </Row>

        <Row style={{ padding: "1em 1.5em" }}>
          <Tabs activeKey={activeTab} onChange={handleTabChange} style={{ width: "100%" }}>
            <TabPane tab="Pending" key="pending">
              <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} spinning={loadingCart}>
                {cartHistoryData?.length === 0 && !loadingCart ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "3rem",
                      color: "#929098",
                      background: "#fff",
                      borderRadius: "12px",
                    }}
                  >
                    No pending bills found
                  </div>
                ) : (
                  <div>
                    {/* Table Header */}
                    <Row
                      style={{
                        background: "#fff",
                        padding: "1rem 1.5rem",
                        borderRadius: "12px 12px 0 0",
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        color: "#5D5A66",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      <Col span={5}>Parked Sale</Col>
                      <Col span={5}>Document No</Col>
                      <Col span={6}>Customer</Col>
                      <Col span={3}>Qty</Col>
                      <Col span={5}>Status</Col>
                    </Row>

                    {/* Table Rows */}
                    {cartHistoryData?.map((record) => (
                      <div key={record.key}>
                        <Row
                          style={{
                            background: "#fff",
                            padding: "1rem 1.5rem",
                            borderBottom: "1px solid #f0f0f0",
                            cursor: "pointer",
                            alignItems: "center",
                            fontSize: "0.95rem",
                          }}
                          onClick={() => toggleExpand(record.key)}
                        >
                          <Col span={5}>
                            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                              {expandedRowKey === record.key ? (
                                <DownOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                              ) : (
                                <RightOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                              )}
                              <span>{dayjs(record.request_date).format("YYYY-MM-DD HH:mm:ss")}</span>
                            </div>
                          </Col>
                          <Col span={5}>
                            <span style={{ fontWeight: 500 }}>{record.cart_no}</span>
                          </Col>
                          <Col span={6}>{record.cart_items?.customer?.name || "Cash & Carry"}</Col>
                          <Col span={3}>{record.cart_items?.totalQty || 0}</Col>
                          <Col span={5}>
                            <span
                              style={{
                                padding: "0.25rem 0.75rem",
                                borderRadius: "6px",
                                fontSize: "0.85rem",
                                fontWeight: 500,
                                background: "#fff4e6",
                                color: "#fa8c16",
                              }}
                            >
                              Parked
                            </span>
                          </Col>
                        </Row>

                        {/* Expanded Content */}
                        {expandedRowKey === record.key && (
                          <div
                            style={{
                              background: "#fafafa",
                              padding: "1.5rem",
                              borderBottom: "1px solid #f0f0f0",
                            }}
                          >
                            {/* Items Table */}
                            <div
                              style={{
                                background: "#fff",
                                borderRadius: "8px",
                                padding: "1rem",
                                marginBottom: "1rem",
                              }}
                            >
                              <Row
                                style={{
                                  fontWeight: 600,
                                  fontSize: "0.85rem",
                                  color: "#5D5A66",
                                  padding: "0.5rem 0",
                                  borderBottom: "1px solid #f0f0f0",
                                }}
                              >
                                <Col span={10}>Description</Col>
                                <Col span={4} style={{ textAlign: "center" }}>
                                  Qty
                                </Col>
                                <Col span={5} style={{ textAlign: "right" }}>
                                  Unit Price
                                </Col>
                                <Col span={5} style={{ textAlign: "right" }}>
                                  Net Total
                                </Col>
                              </Row>

                              {record.cart_items?.items?.map((item, index) => (
                                <Row
                                  key={item.lineId || index}
                                  style={{
                                    padding: "0.75rem 0",
                                    borderBottom: index < record.cart_items.items.length - 1 ? "1px solid #f5f5f5" : "none",
                                    fontSize: "0.9rem",
                                  }}
                                >
                                  <Col span={10}>
                                    <div>{item.value}</div>
                                    {item.name2 && <div style={{ fontSize: "0.8rem", color: "#929098", marginTop: "0.25rem" }}>{item.name2}</div>}
                                  </Col>
                                  <Col span={4} style={{ textAlign: "center" }}>
                                    {item.key + 1}
                                  </Col>
                                  <Col span={5} style={{ textAlign: "right" }}>
                                    {item.unitPrice?.toFixed(2)}
                                  </Col>
                                  <Col span={5} style={{ textAlign: "right", fontWeight: 500 }}>
                                    {item.linenet?.toFixed(2)}
                                  </Col>
                                </Row>
                              ))}
                            </div>

                            {/* Summary Section */}
                            <Row>
                              <Col span={14}></Col>
                              <Col span={10}>
                                <div
                                  style={{
                                    background: "#fff",
                                    borderRadius: "8px",
                                    padding: "1rem",
                                  }}
                                >
                                  <Row
                                    style={{
                                      marginBottom: "0.5rem",
                                      fontSize: "0.9rem",
                                    }}
                                  >
                                    <Col span={12}>Subtotal</Col>
                                    <Col span={12} style={{ textAlign: "right" }}>
                                      {record.cart_items?.subTotal?.toFixed(2)}
                                    </Col>
                                  </Row>
                                  <Row
                                    style={{
                                      marginBottom: "0.75rem",
                                      fontSize: "0.9rem",
                                      paddingBottom: "0.75rem",
                                      borderBottom: "1px solid #f0f0f0",
                                    }}
                                  >
                                    <Col span={12}>Total tax</Col>
                                    <Col span={12} style={{ textAlign: "right" }}>
                                      {record.cart_items?.tax?.toFixed(2)}
                                    </Col>
                                  </Row>
                                  <Row
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "1rem",
                                    }}
                                  >
                                    <Col span={12}>SALE TOTAL</Col>
                                    <Col span={12} style={{ textAlign: "right" }}>
                                      {record.cart_items?.total?.toFixed(2)}
                                    </Col>
                                  </Row>
                                </div>
                                {/* Retrieve Button - Only in Pending Tab */}
                                {record?.status !== "REQ" && (
                                  <button
                                    onClick={() => handleRetrieve(record)}
                                    style={{
                                      width: "100%",
                                      marginTop: "1rem",
                                      padding: "0.75rem",
                                      background: "#1890ff",
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: "8px",
                                      fontSize: "0.95rem",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                    }}
                                  >
                                    Retrieve sale
                                  </button>
                                )}

                                <button
                                  onClick={() => handleCancelSale(record)}
                                  style={{
                                    width: "100%",
                                    marginTop: "0.5rem",
                                    padding: "0.75rem",
                                    background: "#fff",
                                    color: "#ff4d4f",
                                    border: "1px solid #ff4d4f",
                                    borderRadius: "8px",
                                    fontSize: "0.95rem",
                                    fontWeight: 500,
                                    cursor: "pointer",
                                  }}
                                >
                                  Cancel sale
                                </button>
                              </Col>
                            </Row>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </Spin>
            </TabPane>

            <TabPane tab="Processed" key="processed">
              <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} spinning={loadingCart}>
                {cartHistoryData?.length === 0 && !loadingCart ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "3rem",
                      color: "#929098",
                      background: "#fff",
                      borderRadius: "12px",
                    }}
                  >
                    No processed bills found
                  </div>
                ) : (
                  <div>
                    {/* Table Header */}
                    <Row
                      style={{
                        background: "#fff",
                        padding: "1rem 1.5rem",
                        borderRadius: "12px 12px 0 0",
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        color: "#5D5A66",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      <Col span={5}>Parked Sale</Col>
                      <Col span={5}>Document No</Col>
                      <Col span={6}>Customer</Col>
                      <Col span={3}>Qty</Col>
                      <Col span={5}>Status</Col>
                    </Row>

                    {/* Table Rows */}
                    {cartHistoryData?.map((record) => (
                      <div key={record.key}>
                        <Row
                          style={{
                            background: "#fff",
                            padding: "1rem 1.5rem",
                            borderBottom: "1px solid #f0f0f0",
                            cursor: "pointer",
                            alignItems: "center",
                            fontSize: "0.95rem",
                          }}
                          onClick={() => toggleExpand(record.key)}
                        >
                          <Col span={5}>
                            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                              {expandedRowKey === record.key ? (
                                <DownOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                              ) : (
                                <RightOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                              )}
                              <span>{dayjs(record.request_date).format("YYYY-MM-DD HH:mm:ss")}</span>
                            </div>
                          </Col>
                          <Col span={5}>
                            <span style={{ fontWeight: 500 }}>{record.cart_no}</span>
                          </Col>
                          <Col span={6}>{record.cart_items?.customer?.name || "Cash & Carry"}</Col>
                          <Col span={3}>{record.cart_items?.totalQty || 0}</Col>
                          <Col span={5}>
                            <span
                              style={{
                                padding: "0.25rem 0.75rem",
                                borderRadius: "6px",
                                fontSize: "0.85rem",
                                fontWeight: 500,
                                background: "#e6f7ff",
                                color: "#1890ff",
                              }}
                            >
                              Completed
                            </span>
                          </Col>
                        </Row>

                        {/* Expanded Content - View Only (No Retrieve Button) */}
                        {expandedRowKey === record.key && (
                          <div
                            style={{
                              background: "#fafafa",
                              padding: "1.5rem",
                              borderBottom: "1px solid #f0f0f0",
                            }}
                          >
                            {/* Items Table */}
                            <div
                              style={{
                                background: "#fff",
                                borderRadius: "8px",
                                padding: "1rem",
                                marginBottom: "1rem",
                              }}
                            >
                              <Row
                                style={{
                                  fontWeight: 600,
                                  fontSize: "0.85rem",
                                  color: "#5D5A66",
                                  padding: "0.5rem 0",
                                  borderBottom: "1px solid #f0f0f0",
                                }}
                              >
                                <Col span={10}>Description</Col>
                                <Col span={4} style={{ textAlign: "center" }}>
                                  Qty
                                </Col>
                                <Col span={5} style={{ textAlign: "right" }}>
                                  Unit Price
                                </Col>
                                <Col span={5} style={{ textAlign: "right" }}>
                                  Net Total
                                </Col>
                              </Row>

                              {record.cart_items?.items?.map((item, index) => (
                                <Row
                                  key={item.lineId || index}
                                  style={{
                                    padding: "0.75rem 0",
                                    borderBottom: index < record.cart_items.items.length - 1 ? "1px solid #f5f5f5" : "none",
                                    fontSize: "0.9rem",
                                  }}
                                >
                                  <Col span={10}>
                                    <div>{item.value}</div>
                                    {item.name2 && <div style={{ fontSize: "0.8rem", color: "#929098", marginTop: "0.25rem" }}>{item.name2}</div>}
                                  </Col>
                                  <Col span={4} style={{ textAlign: "center" }}>
                                    {item.key + 1}
                                  </Col>
                                  <Col span={5} style={{ textAlign: "right" }}>
                                    {item.unitPrice?.toFixed(2)}
                                  </Col>
                                  <Col span={5} style={{ textAlign: "right", fontWeight: 500 }}>
                                    {item.linenet?.toFixed(2)}
                                  </Col>
                                </Row>
                              ))}
                            </div>

                            {/* Summary Section - View Only */}
                            <Row>
                              <Col span={14}></Col>
                              <Col span={10}>
                                <div
                                  style={{
                                    background: "#fff",
                                    borderRadius: "8px",
                                    padding: "1rem",
                                  }}
                                >
                                  <Row
                                    style={{
                                      marginBottom: "0.5rem",
                                      fontSize: "0.9rem",
                                    }}
                                  >
                                    <Col span={12}>Subtotal</Col>
                                    <Col span={12} style={{ textAlign: "right" }}>
                                      {record.cart_items?.subTotal?.toFixed(2)}
                                    </Col>
                                  </Row>
                                  <Row
                                    style={{
                                      marginBottom: "0.75rem",
                                      fontSize: "0.9rem",
                                      paddingBottom: "0.75rem",
                                      borderBottom: "1px solid #f0f0f0",
                                    }}
                                  >
                                    <Col span={12}>Total tax</Col>
                                    <Col span={12} style={{ textAlign: "right" }}>
                                      {record.cart_items?.tax?.toFixed(2)}
                                    </Col>
                                  </Row>
                                  <Row
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "1rem",
                                    }}
                                  >
                                    <Col span={12}>SALE TOTAL</Col>
                                    <Col span={12} style={{ textAlign: "right" }}>
                                      {record.cart_items?.total?.toFixed(2)}
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </Spin>
            </TabPane>

            <TabPane tab="Cancelled" key="cancelled">
              <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} spinning={loadingCart}>
                {cartHistoryData?.length === 0 && !loadingCart ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "3rem",
                      color: "#929098",
                      background: "#fff",
                      borderRadius: "12px",
                    }}
                  >
                    No cancelled bills found
                  </div>
                ) : (
                  <div>
                    {/* Table Header */}
                    <Row
                      style={{
                        background: "#fff",
                        padding: "1rem 1.5rem",
                        borderRadius: "12px 12px 0 0",
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        color: "#5D5A66",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      <Col span={5}>Parked Sale</Col>
                      <Col span={5}>Document No</Col>
                      <Col span={6}>Customer</Col>
                      <Col span={3}>Qty</Col>
                      <Col span={5}>Status</Col>
                    </Row>

                    {/* Table Rows */}
                    {cartHistoryData?.map((record) => (
                      <div key={record.key}>
                        <Row
                          style={{
                            background: "#fff",
                            padding: "1rem 1.5rem",
                            borderBottom: "1px solid #f0f0f0",
                            cursor: "pointer",
                            alignItems: "center",
                            fontSize: "0.95rem",
                          }}
                          onClick={() => toggleExpand(record.key)}
                        >
                          <Col span={5}>
                            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                              {expandedRowKey === record.key ? (
                                <DownOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                              ) : (
                                <RightOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                              )}
                              <span>{dayjs(record.request_date).format("YYYY-MM-DD HH:mm:ss")}</span>
                            </div>
                          </Col>
                          <Col span={5}>
                            <span style={{ fontWeight: 500 }}>{record.cart_no}</span>
                          </Col>
                          <Col span={6}>{record.cart_items?.customer?.name || "Cash & Carry"}</Col>
                          <Col span={3}>{record.cart_items?.totalQty || 0}</Col>
                          <Col span={5}>
                            <span
                              style={{
                                padding: "0.25rem 0.75rem",
                                borderRadius: "6px",
                                fontSize: "0.85rem",
                                fontWeight: 500,
                                background: "#fff1f0",
                                color: "#ff4d4f",
                              }}
                            >
                              Cancelled
                            </span>
                          </Col>
                        </Row>

                        {/* Expanded Content - View Only (No Retrieve Button) */}
                        {expandedRowKey === record.key && (
                          <div
                            style={{
                              background: "#fafafa",
                              padding: "1.5rem",
                              borderBottom: "1px solid #f0f0f0",
                            }}
                          >
                            {/* Items Table */}
                            <div
                              style={{
                                background: "#fff",
                                borderRadius: "8px",
                                padding: "1rem",
                                marginBottom: "1rem",
                              }}
                            >
                              <Row
                                style={{
                                  fontWeight: 600,
                                  fontSize: "0.85rem",
                                  color: "#5D5A66",
                                  padding: "0.5rem 0",
                                  borderBottom: "1px solid #f0f0f0",
                                }}
                              >
                                <Col span={10}>Description</Col>
                                <Col span={4} style={{ textAlign: "center" }}>
                                  Qty
                                </Col>
                                <Col span={5} style={{ textAlign: "right" }}>
                                  Unit Price
                                </Col>
                                <Col span={5} style={{ textAlign: "right" }}>
                                  Net Total
                                </Col>
                              </Row>

                              {record.cart_items?.items?.map((item, index) => (
                                <Row
                                  key={item.lineId || index}
                                  style={{
                                    padding: "0.75rem 0",
                                    borderBottom: index < record.cart_items.items.length - 1 ? "1px solid #f5f5f5" : "none",
                                    fontSize: "0.9rem",
                                  }}
                                >
                                  <Col span={10}>
                                    <div>{item.value}</div>
                                    {item.name2 && <div style={{ fontSize: "0.8rem", color: "#929098", marginTop: "0.25rem" }}>{item.name2}</div>}
                                  </Col>
                                  <Col span={4} style={{ textAlign: "center" }}>
                                    {item.key + 1}
                                  </Col>
                                  <Col span={5} style={{ textAlign: "right" }}>
                                    {item.unitPrice?.toFixed(2)}
                                  </Col>
                                  <Col span={5} style={{ textAlign: "right", fontWeight: 500 }}>
                                    {item.linenet?.toFixed(2)}
                                  </Col>
                                </Row>
                              ))}
                            </div>

                            {/* Summary Section - View Only */}
                            <Row>
                              <Col span={14}></Col>
                              <Col span={10}>
                                <div
                                  style={{
                                    background: "#fff",
                                    borderRadius: "8px",
                                    padding: "1rem",
                                  }}
                                >
                                  <Row
                                    style={{
                                      marginBottom: "0.5rem",
                                      fontSize: "0.9rem",
                                    }}
                                  >
                                    <Col span={12}>Subtotal</Col>
                                    <Col span={12} style={{ textAlign: "right" }}>
                                      {record.cart_items?.subTotal?.toFixed(2)}
                                    </Col>
                                  </Row>
                                  <Row
                                    style={{
                                      marginBottom: "0.75rem",
                                      fontSize: "0.9rem",
                                      paddingBottom: "0.75rem",
                                      borderBottom: "1px solid #f0f0f0",
                                    }}
                                  >
                                    <Col span={12}>Total tax</Col>
                                    <Col span={12} style={{ textAlign: "right" }}>
                                      {record.cart_items?.tax?.toFixed(2)}
                                    </Col>
                                  </Row>
                                  <Row
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "1rem",
                                    }}
                                  >
                                    <Col span={12}>SALE TOTAL</Col>
                                    <Col span={12} style={{ textAlign: "right" }}>
                                      {record.cart_items?.total?.toFixed(2)}
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </Spin>
            </TabPane>
          </Tabs>
        </Row>
      </div>
    );
  }

  // Fallback: old-style parked bills view (saveParkedBills !== "Y")
  return (
    <div
      style={{
        background: colorVariable ? colorVariable : "#f3f4f9",
        height: "100vh",
      }}
    >
      <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
        <Col
          span={6}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.8vw",
          }}
        >
          <img
            src={Back}
            id="sm-parked-bill-back"
            onClick={() => {
              setIsparkedBill(false);
              setIsInputFocused(false);
              setParkedBillSearchInput("");
              setLayoutName("default");
              setFilterdParkedList(parkedList);
            }}
            style={{
              height: "2.2vw",
              cursor: "pointer",
            }}
          />
          <span
            style={{
              fontSize: "1.8em",
              fontWeight: 500,
              color: "#0F0718",
              lineHeight: 1,
            }}
          >
            Parked Bills
          </span>
        </Col>
        <Col
          span={18}
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <Input
            placeholder={`Search for customers`}
            ref={parkedBillRef}
            prefix={<img src={CustomerSearch} style={{ width: "1.5em", margin: "0.75em" }} alt="" />}
            allowClear={false}
            style={{ width: "70%", borderRadius: "5px", border: "none" }}
            onPressEnter={() => {
              searchParkedBill(parkedBillSearchInput);
            }}
            onChange={(e) => {
              onChangeParkedBill(e.target.value);
              keyboard?.current?.setInput(e.target.value);
            }}
            id="sm-parked-bill-customer"
            onFocus={() => {
              setTimeout(() => {
                setInputName("parkedBill");
                setOpen(true);
                keyboard?.current?.setInput(parkedBillSearchInput);
              }, 300);
            }}
            onBlur={() => {
              setIsInputFocused(false);
            }}
            value={parkedBillSearchInput}
            className="parkedCustomer-sm"
            width={700}
          />
        </Col>
      </Row>
      <br />
      <Row style={{ padding: "0 1em" }}>
        <Table
          style={{
            width: "100%",
            overflowY: "auto",
            border: "none",
            fontSize: "1vw",
            borderRadius: "10px",
            padding: "0 1em",
            height: "83vh",
            background: themeJSON.productTableBGColor || "#fff",
          }}
          pagination={false}
          columns={columns}
          dataSource={filterdParkedList}
          rowClassName={(record) => (selectedKeys[0] === record.key ? "tableSelectedBlue" : "tableNonSelectedWhite")}
          className="sm-cart-table"
          expandable={{
            expandedRowKeys,
            onExpand: handleExpandPerkedData,
            expandedRowRender: (record) => (
              <div
                style={{
                  padding: "1% 4% 1% 4%",
                  backgroundColor: "#f3f4f9",
                }}
              >
                <Row>
                  <Col span={21}>
                    <Row>
                      <Col span={12} className="td-nested-title-sm">
                        Description
                      </Col>
                      <Col span={3} className="td-nested-title-sm" style={{ textAlign: "center" }}>
                        Qty
                      </Col>
                      <Col span={3} offset={1} className="td-nested-title-sm" style={{ textAlign: "center" }}>
                        Unit Price
                      </Col>
                      <Col span={3} offset={1} className="td-nested-title-sm" style={{ textAlign: "right" }}>
                        Net Total
                      </Col>
                    </Row>
                    <Row style={{ paddingBottom: "0.5vw", fontSize: "1vw" }}>
                      {record.parkedCart.items.map((e) => {
                        return (
                          <>
                            <Col span={12} className="td-nested-title-sm" style={{ fontSize: "1.2em" }}>
                              {e.name}
                            </Col>
                            <Col
                              span={3}
                              style={{
                                textAlign: "center",
                                fontWeight: "400",
                                fontSize: "1.2em",
                              }}
                            >
                              {e.weight}
                            </Col>
                            <Col span={1} style={{ textAlign: "center" }} />
                            <Col
                              span={3}
                              style={{
                                textAlign: "right",
                                fontWeight: "400",
                                paddingRight: "1vw",
                                fontSize: "1.2em",
                              }}
                            >
                              {e.realPrice}
                            </Col>
                            <Col span={1} style={{ textAlign: "right" }} />
                            <Col
                              span={3}
                              style={{
                                textAlign: "right",
                                marginLeft: "6vw",
                                fontWeight: "400",
                                fontSize: "1.2em",
                              }}
                            >
                              {e.nettotal.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)}
                            </Col>
                          </>
                        );
                      })}
                    </Row>
                    <p
                      style={{
                        width: "96%",
                        marginLeft: "0%",
                        borderTop: "1.3px solid rgba(52, 40, 44, 0.55)",
                        marginBottom: "0px",
                      }}
                    />
                    <Row style={{ paddingTop: "5px" }}>
                      <Col span={3} offset={17} className="td-subtotal">
                        <span className="td-subTotalText">Subtotal</span>
                        <span className="td-subTotalText">Total tax</span>
                      </Col>
                      <Col span={3} className="td-subtotal" style={{ textAlign: "right" }}>
                        <span className="td-subTotalText">{(record.parkedCart.total - record.parkedCart.tax).toFixed(pricePrecision)}</span>
                        <span className="td-subTotalText">{record.parkedCart.tax.toFixed(pricePrecision)}</span>
                      </Col>
                    </Row>
                    <Row style={{ marginBottom: "1%" }}>
                      <Col span={3} offset={17} className="td-subtotal" style={{ padding: "4px 0" }}>
                        <span className="td-total">SALE TOTAL</span>
                      </Col>
                      <Col
                        span={3}
                        className="td-subtotal"
                        style={{
                          borderBottom: "1px solid rgba(52, 40, 44, 0.55)",
                          textAlign: "right",
                          paddingTop: "4px",
                        }}
                      >
                        <span className="td-total">{record.parkedCart.total}</span>
                      </Col>
                    </Row>
                  </Col>
<Col
  span={3}
  className="td-bottons"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "0.5vw",
    justifyContent: "center",
  }}
>
                    <p
                      style={{
                        cursor: "pointer",
                        padding: "5.5% 12%",
                        borderRadius: "3px",
                        border: "1px solid #fff",
                        background: "#fff",
                        fontSize: "1em",
    margin: 0,
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
                      }}
                      onClick={() => {
                        setTableValue("POS");
                        retrieveParkedData(record);
                        upsertPOSLog(cart, "OPK", "Retrieved");
                      }}
                      id="sm-parked-bill-retrieve"
                    >
                      <img
                        src={Retrieve}
                        style={{
                          height: "1vw",
                          paddingRight: "0.4vw",
                          cursor: "pointer",
                        }}
                      />
                      Retrieve sale
                    </p>
                    <p
                      style={{
                        cursor: "pointer",
                        padding: "5.5% 13%",
                        borderRadius: "3px",
                        border: "1px solid #fff",
                        background: "#fff",
                        fontSize: "1em",
    margin: 0,
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
                      }}
                      onClick={() => {
                        setParkedBill(record);
                        discardMessage("Discard Sale", "Are you sure you want to discard the sale!", record);
                      }}
                      id="sm-parked-bill-discard"
                    >
                      <img src={Cancel} style={{ height: "1.1vw", paddingRight: "0.4vw" }} />
                      Discard sale
                    </p>
                  </Col>
                </Row>
              </div>
            ),
            expandIcon: ({ expanded, onExpand, record }) => (
              <span id="sm-parked-bill-expand" onClick={(e) => onExpand(record, e)}>
                {expanded ? <DownOutlined style={{ color: "#929098" }} /> : <RightOutlined style={{ color: "#929098" }} />}
              </span>
            ),
          }}
          onRow={(record) => ({
            onClick: () => handleExpandPerkedData(record),
          })}
          onExpand={handleExpandPerkedData}
        />
      </Row>
    </div>
  );
};

export default SMParkedBillsView;
